import {
  Inject,
  Module,
  NotImplementedException,
  OnModuleInit,
} from '@nestjs/common';

import { NotificationDataAccessService } from './services/notification-data-access.service';
import { UnknownNotificationMessengerServiceParameterException } from './exceptions';
import { NotificationDataAccessWithConsoleService } from './services/notification-data-access-with-console.service';
import { MESSENGER_SERVICE, ServerConfigModule } from '@ip6m/server/config';
import * as Joi from 'joi';

@Module({
  imports: [ServerConfigModule],
  providers: [
    {
      provide: NotificationDataAccessService,
      inject: [MESSENGER_SERVICE],
      useFactory: (messengerService: string) => {
        switch (messengerService) {
          case 'console':
            return new NotificationDataAccessWithConsoleService();

          case 'email':
            throw new NotImplementedException();

          default:
            throw new UnknownNotificationMessengerServiceParameterException(
              messengerService
            );
        }
      },
    },
  ],
  exports: [
    NotificationDataAccessService],
})
export class ServerDataAccessNotificationModule implements OnModuleInit {
  constructor(@Inject(MESSENGER_SERVICE) private messengerService: string) {}

  onModuleInit(): any {
    const schema = Joi.object({
      messengerService: Joi.string().valid('console', 'email'),
    });
    Joi.assert(this, schema);
  }
}
